import * as yup from 'yup';
import { stringRequired } from 'Utils/Validation';

const AwardDateSchema = yup.object().shape({
  awardDate: stringRequired({}).nullable(),
});
export default AwardDateSchema;
